import * as React from "react";
import { useRouter } from "next/router";
import { Button } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { connect, useIntl } from "@grandvisionhq/state";
import { getAuth } from "../../selectors.js";
/* empty css              */
import { logOut } from "../../Logout/Logout/actions.js";
const LoggedIn = ({
  auth,
  disableContinue,
  onLogoutClick,
  onContinueClick
}) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const { asPath: returnPath } = useRouter();
  return /* @__PURE__ */ React.createElement("div", { className: "logged-in__container" }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", className: "checkout-step__title logged-in__title" }, getLabel("account.alreadyLoggedIn.title")), /* @__PURE__ */ React.createElement("p", null, getFormattedLabel("account.alreadyLoggedIn.text", {
    labelData: { email: auth.email }
  })), !disableContinue && /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "logged-in__button logged-in__button-continue",
      "data-t": "continue",
      caption: getLabel("common.actions.continue"),
      onClick: onContinueClick
    }
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "logged-in__button logged-in__button-logout",
      "data-t": "logout",
      caption: getLabel("account.action.logout"),
      onClick: () => onLogoutClick(returnPath),
      variant: "outline"
    }
  ));
};
const mapStateToProps = (state) => ({
  auth: getAuth(state)
});
const mapDispatchToProps = {
  onLogoutClick: logOut
};
const LoggedIn$1 = connect(mapStateToProps, mapDispatchToProps)(LoggedIn);
export {
  LoggedIn,
  LoggedIn$1 as default,
  mapDispatchToProps,
  mapStateToProps
};
//# sourceMappingURL=LoggedIn.js.map
